var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValvoline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 14,
    viewBox: "0 0 88 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34389_53887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0844 0.348154L7.70727 8.96243L4.27907 0.348154H0.150635L5.66493 13.4993H9.56725L15.0305 0.348154H11.0844Z",
    fill: "#E3EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.087 0.253214H24.4399V13.5138H28.087V0.253214Z",
    fill: "#E3EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.053 0.253214H51.406V13.5138H55.053V0.253214Z",
    fill: "#E3EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3655 3.16358L34.4107 10.0127L32.434 3.16358L28.5828 3.15628L32.0328 13.5138H36.4822L39.9177 3.16358H36.3655Z",
    fill: "#E3EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8596 3.1635H56.2053V13.5138H59.8596V3.1635Z",
    fill: "#E3EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8596 0.253214H56.2053V2.20072H59.8596V0.253214Z",
    fill: "#E3EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1531 3.1635H61.0269V13.5138H64.6739V5.30795H67.4164V13.521H71.0708V5.80394C71.0708 3.72514 69.7578 3.1635 68.1531 3.1635Z",
    fill: "#E3EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5839 13.5138C49.3637 13.5138 50.2463 12.6531 50.2463 11.0703C50.2463 9.66258 50.2536 5.70191 50.2536 5.70191C50.2536 3.58663 48.8531 3.15628 47.5475 3.15628H42.7845C41.4788 3.15628 40.0784 3.58663 40.0784 5.70191C40.0784 5.70191 40.0857 9.65528 40.0857 11.0703C40.0857 12.6531 40.9682 13.5138 42.7553 13.5138H47.5839ZM43.7692 11.3694V5.35179L46.5774 5.29344V11.3694H43.7692Z",
    fill: "#E3EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2436 5.80394C23.2436 3.72514 21.9234 3.1635 20.1363 3.1635H14.9211L14.1114 5.11101H19.6112V6.58441H15.9204C14.4178 6.58441 13.0173 7.0804 13.0173 9.22485V11.238C13.0173 12.7843 13.9364 13.5138 15.8401 13.5138C17.2916 13.5138 23.2509 13.5065 23.2509 13.5065L23.2436 5.80394ZM19.6039 11.3693H16.5039V8.53921H19.6039V11.3693Z",
    fill: "#E3EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1428 5.94253V10.866C72.1428 11.8142 72.4711 12.3832 72.6972 12.6312C73.1713 13.1782 73.9226 13.5138 75.272 13.5138H81.0926L81.6105 11.5589H75.7753V9.88861H79.6484C81.2531 9.88861 82.2378 9.2832 82.2378 7.48887V5.56324C82.2378 3.68867 80.9978 3.1635 79.3639 3.1635H75.2355C73.4266 3.1635 72.1428 3.95126 72.1428 5.94253ZM75.7826 5.30795H78.8825V7.94839H75.7826V5.30795Z",
    fill: "#E3EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1716 11.9529V11.4569H84.9951V11.9529H84.3751V13.5284H83.7697V11.9529H83.1716ZM86.0309 11.4569L86.4102 12.6458L86.7822 11.4569H87.6429V13.5284H87.0958V12.0331L86.6436 13.5284H86.1841L85.7391 12.0331V13.5284H85.1848V11.4642L86.0309 11.4569Z",
    fill: "#E3EAE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34389_53887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.4848,
    height: 13.2752,
    fill: "white",
    transform: "translate(0.150635 0.253174)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValvoline);
export default __webpack_public_path__ + "static/media/valvoline.86ca870c2e1f9e5b703412a70264463b.svg";
export { ForwardRef as ReactComponent };